export const DEPARTMENT_OPTIONS = [
  { value: "corporate", labelKey: "auth.departmentOptions.corporate" },
  { value: "retail", labelKey: "auth.departmentOptions.retail" },
];

const LOGIN_ERROR_MAP = {
  invalid_payload: "auth.errors.login.invalidPayload",
  invalid_credentials: "auth.errors.login.invalidCredentials",
  permissions_unavailable: "auth.errors.permissionsUnavailable",
};

const REGISTER_ERROR_MAP = {
  invalid_payload: "auth.errors.register.invalidPayload",
  invalid_department: "auth.errors.register.invalidDepartment",
  invalid_password: "auth.errors.register.invalidPassword",
  invalid_private_key: "auth.errors.register.invalidPrivateKey",
  member_exists: "auth.errors.register.memberExists",
};

const CHANGE_PASSWORD_ERROR_MAP = {
  invalid_payload: "auth.errors.changePassword.invalidPayload",
  invalid_password: "auth.errors.changePassword.invalidPassword",
  same_password: "auth.errors.changePassword.samePassword",
  invalid_current_password: "auth.errors.changePassword.invalidCurrentPassword",
  invalid_auth_token: "auth.errors.changePassword.invalidAuthToken",
  member_not_found: "auth.errors.changePassword.memberNotFound",
};

const RESET_PASSWORD_ERROR_MAP = {
  invalid_payload: "auth.errors.resetPassword.invalidPayload",
  invalid_password: "auth.errors.resetPassword.invalidPassword",
  invalid_reset_token: "auth.errors.resetPassword.invalidToken",
  expired_reset_token: "auth.errors.resetPassword.expiredToken",
};

export const getLoginErrorKey = (error) =>
  LOGIN_ERROR_MAP[error?.error_code] || "auth.errors.generic";

export const getRegisterErrorKey = (error) =>
  REGISTER_ERROR_MAP[error?.error_code] || "auth.errors.generic";

export const getChangePasswordErrorKey = (error) =>
  CHANGE_PASSWORD_ERROR_MAP[error?.error_code] || "auth.errors.generic";

export const getResetPasswordErrorKey = (error) =>
  RESET_PASSWORD_ERROR_MAP[error?.error_code] || "auth.errors.generic";

export const validateRegisterForm = ({ password, confirmPassword }) => {
  if (!password || !confirmPassword) {
    return "auth.errors.register.invalidPayload";
  }

  if (password !== confirmPassword) {
    return "auth.errors.passwordsMustMatch";
  }

  return "";
};

export const validateChangePasswordForm = ({
  currentPassword,
  newPassword,
  confirmNewPassword,
}) => {
  if (!currentPassword || !newPassword || !confirmNewPassword) {
    return "auth.errors.changePassword.invalidPayload";
  }

  if (newPassword !== confirmNewPassword) {
    return "auth.errors.passwordsMustMatch";
  }

  if (newPassword.length < 8) {
    return "auth.errors.changePassword.invalidPassword";
  }

  if (newPassword === currentPassword) {
    return "auth.errors.changePassword.samePassword";
  }

  return "";
};

export const validateForgotPasswordForm = ({ email }) => {
  if (!email) {
    return "auth.errors.forgotPassword.invalidPayload";
  }

  return "";
};

export const validateResetPasswordForm = ({
  token,
  newPassword,
  confirmNewPassword,
}) => {
  if (!token || !newPassword || !confirmNewPassword) {
    return "auth.errors.resetPassword.invalidPayload";
  }

  if (newPassword !== confirmNewPassword) {
    return "auth.errors.passwordsMustMatch";
  }

  if (newPassword.length < 8) {
    return "auth.errors.resetPassword.invalidPassword";
  }

  return "";
};
